
const defaultState = {
  loading: true,
  sbtTemplates: [],
  newsletterTemplates: [],
  sbtTemplateSources: [],
  templateSbtEdit: undefined,
  templateNewsletterEdit: undefined,
  activeTab: '1'
};

export default (state = defaultState, action) => {

  switch (action.type) {
    case 'TEMPLATES_SBT_FETCH_BEGIN':
      return { ...defaultState };
    case 'TEMPLATES_SBT_FETCH_SUCCESS':
      return { ...state, sbtTemplates: action.payload.templates, sbtTemplateSources: action.payload.sources, loading: false };
    case 'TEMPLATES_NEWSLETTER_FETCH_SUCCESS':
      return { ...state, newsletterTemplates: action.payload, loading: false };
    case 'TEMPLATES_SBT_EDIT':
      return { ...state, templateSbtEdit: action.payload };
    case 'TEMPLATES_NEWSLETTER_EDIT':
      return { ...state, templateNewsletterEdit: action.payload };
    case 'TEMPLATES_SBT_EDIT_CANCEL':
      return { ...state, templateSbtEdit: undefined };
    case 'TEMPLATES_NEWSLETTER_EDIT_CANCEL':
      return { ...state, templateNewsletterEdit: undefined };
    case 'TEMPLATES_SBT_SAVE_SUCCESS':
      return { ...state, templateSbtEdit: undefined, sbtTemplates: action.payload };
    case 'TEMPLATES_NEWSLETTER_SAVE_SUCCESS':
      return { ...state, templateNewsletterEdit: undefined, newsletterTemplates: action.payload };
    case 'TEMPLATES_SBT_ATTR_EDIT':
      let templateResult = { ...state };
      templateResult.templateSbtEdit[action.payload.attr] = action.payload.value;
      return templateResult;
    case 'TEMPLATES_NEWSLETTER_ATTR_EDIT':
      let templateNewsletterResult = { ...state };
      templateNewsletterResult.templateNewsletterEdit[action.payload.attr] = action.payload.value;
      return templateNewsletterResult;
    case 'TEMPLATES_CHANGE_TAB':
      return { ...state, activeTab: action.payload };
    case 'TEMPLATES_SBT_DELETE_SUCCESS':
      return { ...state, templateSbtEdit: undefined, sbtTemplates: action.payload.templates, sbtTemplateSources: action.payload.sources, loading: false };
    case 'TEMPLATES_NEWSLETTER_DELETE_SUCCESS':
      return { ...state, templateNewsletterEdit: undefined, newsletterTemplates: action.payload, loading: false };
    default:

      return state;
  }
}



// WEBPACK FOOTER //
// ./src/templates/templatesReducer.js